import { render, staticRenderFns } from "./Instructions.vue?vue&type=template&id=169f9cb9&scoped=true&"
var script = {}
import style0 from "./Instructions.vue?vue&type=style&index=0&id=169f9cb9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169f9cb9",
  null
  
)

export default component.exports